<script lang="ts" setup>
import Dialog from './AppDialog.vue';

interface Props {
  title: string;
  subtitle: string;
  item?: string;
  modelValue: boolean;
  size?: 'small' | 'medium' | 'large';
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: 'cancel'): void;
  (e: 'confirm', item?: string): void;
  (e: 'update:modelValue', val: boolean): void;
}>();

const isModalActive = computed({
  set(newValue: boolean) {
    emit('update:modelValue', newValue);
  },
  get() {
    return props.modelValue;
  },
});

function cancel() {
  emit('cancel');
  isModalActive.value = false;
}
</script>

<template>
  <Dialog
    v-model="isModalActive"
    :title="props.title"
    :subtitle="props.subtitle"
    :size="props.size"
    has-icon
  >
    <template #icon>
      <UiIcon name="AlertCircle" :size="20" />
    </template>

    <template #actions>
      <div class="button-row">
        <UiButton @click="cancel">
          {{ $t('button.cancel') }}
        </UiButton>
        <UiButton variant="primary" @click="emit('confirm', props.item)">
          {{ $t('button.proceed') }}
        </UiButton>
      </div>
    </template>
  </Dialog>
</template>

<style lang="scss" scoped>
.button-row {
  margin-top: var(--space-16);
}
</style>
